'use client';

import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { fetchItem } from '@/app/actions/server';
import { useApiErrorContext } from '@/app/components/Provider';
import { EventCode } from '~/model/MailType';

export const SendPersonalData = () => {
  const t = useTranslations('SETTINGS.PERSONAL_DATA.REQUEST');
  const { setError } = useApiErrorContext();

  const [isMailData, setIsMailData] = useState(false);

  const handleAskData = async () => {
    const response = await fetchItem({
      pathname: 'send_mail',
      method: 'POST',
      body: { eventCode: EventCode.personal_data },
      revalidate: 0,
    });

    if (response['hydra:description']) {
      return setError(response);
    }

    setIsMailData(true);
  };

  return isMailData
    ? (
        <span data-testid="mailSent">
          {t('CONFIRMATION')}
        </span>
      )
    : (
        <div>
          <VpButton
            variant="secondary"
            onClick={handleAskData}
          >
            <span data-testid="mailNotSent">
              {t('ACTION')}
            </span>
          </VpButton>
        </div>
      );
};
